import {
    trigger,
    state,
    animate,
    transition,
    style
} from '@angular/animations';

export const slideUpModalAnimation = trigger('slideUpModalAnimation', [
    state(
        '*',
        style({
            'position': 'fixed',
            'top': 0,
            'left': 0,
            'right': 0,
            'bottom': 0,
            'z-index': 80
        })
    ),
    transition(':enter', [
        style({
            transform: 'translateY(100%)'
        }),
        animate(
            '.7s ease-in-out',
            style({
                transform: 'translateY(0)'
            })
        )
    ]),
    transition(':leave', [
        animate(
            '.7s ease-in-out',
            style({
                transform: 'translateY(100%)'
            })
        )
    ])
]);
